import React, { useEffect } from "react";
import { connect } from "react-redux";

import moment from "moment";
import { bindActionCreators, Dispatch } from "redux";

import { MessageMap } from "@plex/culture-core";
import { LocalizationProvider, LocalizationConsumer } from "@plex/culture-react";

import { defaultLocale } from "infrastructure/localization";

import { IAppTranslationState, ISettingsState, ITranslationMessagesLoadParam, appTranslationActions } from "../";

import { Splash } from ".";

interface IAppLocalizerProps {
  currentLocale: string;
  messages: MessageMap;
  isLoading?: boolean;
  isLocaleChanging?: boolean;
  isInitialized?: boolean;
  cacheRefreshTimeInSeconds: number;
  loadMessageTranslations: Function;
}

const AppLocalizer: React.FC<IAppLocalizerProps> = ({
  currentLocale,
  messages,
  isLoading,
  isLocaleChanging,
  isInitialized,
  cacheRefreshTimeInSeconds,
  loadMessageTranslations,
  children
}) => {
  useEffect(() => {
    const refreshTime = moment.duration(cacheRefreshTimeInSeconds, "seconds").asMilliseconds();

    const interval = setInterval(() => {
      loadMessageTranslations();
    }, refreshTime);

    return () => clearInterval(interval);
  }, [loadMessageTranslations, cacheRefreshTimeInSeconds]);

  useEffect(() => {
    const data: ITranslationMessagesLoadParam = {
      loadNewLocale: true
    };
    loadMessageTranslations(data);
  }, [loadMessageTranslations]);

  return isInitialized ? (
    <LocalizationProvider>
      <LocalizationConsumer>
        {ctx => {
          if (isLoading === false || isLocaleChanging === false) {
            ctx.loadMessages(messages || []);
            ctx.setLocale(currentLocale || defaultLocale.localeIdentifier);
          }
          return children;
        }}
      </LocalizationConsumer>
    </LocalizationProvider>
  ) : (
    <Splash />
  );
};

export default connect(
  (state: { appTranslation: IAppTranslationState; settings: ISettingsState }) => {
    return {
      messages: state.appTranslation.messages,
      currentLocale: state.settings.localSettings.locale,
      isLoading: state.appTranslation.isLoading,
      isLocaleChanging: state.settings.localSettings.isLocaleChanging,
      isInitialized: state.appTranslation.isInitialized,
      cacheRefreshTimeInSeconds: state.appTranslation.cacheRefreshTimeInSeconds
    };
  },
  (dispatch: Dispatch) => {
    return bindActionCreators({ loadMessageTranslations: appTranslationActions.loadMessageTranslations }, dispatch);
  }
)(AppLocalizer);
